import axios from "axios";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const fetchPublicSocialMedia = async () => {
 try {
 const response = await axios.get(`${BASE_URL}/public/social-media`);
 return { success: true, data: response.data };
 } catch (err) {
 return { success: false, data: [] };
 }
};
